module.exports = __webpack_public_path__ + "img/new image - meak1.8102acf3.jpg";